import HelpMain from '../../components/Help/HelpMain';
import PageMain from '../../components/Navigation/PageMain/PageMain';

export default function HelpPage() {
    return (
        <PageMain pageTitle="Help" showError={false} showLoading={false}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <HelpMain />
                </div>
            </div>
        </PageMain>
    );
}
